import type { NestedKeyOf } from '@/features/shared/types'
import type { DropdownItem } from '@designSystem/components/basic/dropdown/BasicDropdown.types'
import type { ToggleItem } from "@designSystem/components/basic/toggleSwitch/BasicToggleSwitch.types"

export function objectToDropdownItems(constEnum: object): DropdownItem<string>[] {
  return Object.entries(constEnum).map(([id, label]) => ({
    id,
    label,
  }))
}

export function objectToToggleItems(constEnum: object): ToggleItem<string>[] {
  return Object.entries(constEnum).map(([id, label]) => ({
    id,
    label,
  }))
}

type ObjectIsEmptyOptions<T extends object> = {
  exclude?: NestedKeyOf<T>[],
  nullFilter?: (null | undefined | string | number | boolean)[]
}

export function objectIsEmpty<T extends object>(object?: T | null, options?: ObjectIsEmptyOptions<T>) {
  if (!object) return true

  options = {
    nullFilter: [null, undefined, ""],
    ...options
  }

  const membresExclus = (options.exclude ?? []).filter(item => !item.includes('.')) as string[]

  for (const [membre, valeur] of Object.entries(object)) {
    if (typeof valeur === "function") continue
    if (membresExclus.includes(membre)) continue
    if (Array.isArray(valeur)) {
      for (let index = 0; index < valeur.length; index++) {
        if (options.exclude?.includes(`${membre}.${index}` as any)) continue
        const item = valeur[index]
        if (typeof item === 'object') {
          const path = `${membre}.${index}.`
          const membresEnfantExclus = (options.exclude ?? []).filter(item => item.startsWith(path)).map(item => {
            const tokens = item.split(".")
            return tokens.slice(-tokens.length + 2).join(".")
          })
          const isEmpty = objectIsEmpty(item, { exclude: membresEnfantExclus, nullFilter: options.nullFilter })
          if (!isEmpty) return false
        } else {
          if (!options.nullFilter?.includes(item)) return false
        }
      }
    } else if (typeof valeur === "object" && valeur !== null) {
      const path = `${membre}.`
      const membresEnfantExclus = (options.exclude ?? []).filter(item => item.startsWith(path)).map(item => {
        const tokens = item.split(".")
        return tokens.slice(-tokens.length + 1).join(".")
      })
      const isEmpty = objectIsEmpty(valeur, { exclude: membresEnfantExclus, nullFilter: options.nullFilter })
      if (!isEmpty) return false
    } else {
      if (!options.nullFilter?.includes(valeur)) return false
    }
  }
  return true
}
